import React, { Fragment } from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
//import publicIp = require('public-ip')

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}


const styles = theme => ({
  root: {
    flexGrow: 1,
    minHeight: 400,
    margin: theme.spacing.unit * 2,
  },
  details:{
    margin:  theme.spacing.unit * 2,
  },
  paper:{
 //   marginRight:  theme.spacing.unit * 2,
  },
  nameField:{
    margin: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 4,
  },
  agreement:{
    marginTop:  theme.spacing.unit * 2,
    marginBottom:  theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});


@inject("commonStore")
@observer
class Review extends React.Component {
//export default class IdkTableFormDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  async componentDidMount(){
     //const { handleUpdate } = this.props
     //const userIP = await publicIp.v4() 
     //handleUpdate()
  }
  makeLabel = (value) => {
    if(value){
      const splitArray = value.split('_')
      if(splitArray.length > 1){
        return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
      }
      return jsUcfirst(value)
    }
    return ''
}
 /* makeConditions = () => {
    const { conditions, commonStore } = this.props
    const { include } = conditions
   
    const labels = include.map(condition => {
            return `${jsUcfirst(condition)}; `
    })

    return <Typography variant="body1"> {`Conditions: ${labels.join(' ')}`} </Typography>
  }*/
  /*
  makePovertLevels = () => {
    const { povertyLevels, priceMapType, commonStore, healthy } = this.props
    const { include } = povertyLevels
    const { agent } = commonStore
    const network = mobx.toJS(agent.network)

    const priceMaps = healthy ? network.priceMaps.healthy : network.priceMaps.unhealthy

    console.log(priceMaps)

    const { carte, fixed } = priceMaps

    const priceMap = priceMapType === 'fixed' ? fixed : carte

    const keys = Object.keys(priceMap)
    const labels = keys.map(key => {
        if(include.includes(key)){
            return `Level ${key}: $${priceMap[key] / 100}; `; 
        }
        return null
    })

    return <Typography variant="body1"> {`Poverty Levels: ${labels.join(' ')}`} </Typography>
  }*/
  getRegions = () => {
    const { filters } = this.props
    const { topLevel } = filters
    let regions = []
    console.log(topLevel)
    const regionFilterFound = topLevel.filter((item) => {
      return item.field === 'region'
    })
  
    console.log(regionFilterFound)
  
  
    if(regionFilterFound.length > 0){
      regions = [...regionFilterFound[0].include]
    }
  
    return regions
  }
  makeList = (items) => {
    return items.map((item) => {
        return this.makeLabel(item)
    })
  }
  render() {

    const { classes, commonStore, leadType, qualifiers, contactTypes, filters, amount, agreed, handleUpdate, campaignID, campaignName, priceMapType, fixedCampaignName } = this.props
    
    const { campaign, network } = commonStore
    const { priceMaps } = network
    const { fixed } = priceMaps
    let currentBalance
    let fixedDescription
    if(fixedCampaignName){
      const fixedCampaign = fixed[fixedCampaignName]
      const { description: tempDescription } = fixedCampaign
      fixedDescription = tempDescription
    }

    if(campaign){
      const { balance} = campaign
      currentBalance = balance
    }

    

  
    //need to get name for the campaign
    console.log(this.state)

    return (
        <div className={classes.root}>

            
          <Paper className={classes.paper}>
            <TextField
            id="outlined-full-width"
            label="Campaign Name"
            className={classes.nameField}
            placeholder="My campaign name"
            helperText="Create a descriptive name to help you recognize this campaign"
            fullWidth
            margin="normal"
            variant="outlined"
            value={campaignName ? campaignName : ''}
            onChange={(event) => {handleUpdate('campaignName', event.target.value, true)}}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <div className={classes.details}>
          <Typography variant="body2">Details:</Typography>
          {priceMapType === 'carte' ? 
          <Fragment>
          <Typography variant="body2">{`Lead Type: ${this.makeLabel(leadType)}`} </Typography>
          <Typography variant="body2">{`Qualifiers: ${this.makeList(qualifiers).join(', ')}`} </Typography>
          <Typography variant="body2">{`Contact Types: ${this.makeList(contactTypes).join(', ')}`} </Typography>
          <Typography variant="body2">{`Regions: ${this.getRegions().join(', ')}`} </Typography>
          {campaignID ? <Typography variant="body1">{`Balance ${amount > 0 ? 'added' : 'reduced by'}: $${Math.abs(amount) / 100}`}</Typography> : <Typography variant="body1">{`Balance: $${amount / 100}`}</Typography>}
          {campaignID ? <Typography variant="body1">{`Your new campaign balance after the update will be: $${(currentBalance + amount) / 100}`}</Typography> : null}
          </Fragment> : <Typography variant="body2">{`Combo Deal: ${fixedDescription}`} </Typography>}
          <br/>
          {process.env.REACT_APP_SONIC_ENV === 'dev' ? <Typography variant="body2">{`TEST CAMAPIGN NAME: ${this.makeLabel(leadType)} $${Math.abs(amount) / 100} ${this.makeList(qualifiers).join(', ')} ${this.makeList(contactTypes).join(', ')} ${this.getRegions().join(', ')}`} </Typography> : null }
          </div>

        <Grid item xs={12}>
          <Grid
            container
            spacing={16}
            className={classes.agreement}
            alignItems={'flex-start'}
            direction={'row'}
            justify={'flex-start'}
          >
         
          <Grid item >
              <Checkbox
              color='primary'
              checked={agreed}
              onChange={() => {handleUpdate('agreed', !agreed, true)}}
            />
                {'I have read and agree to the '}
                <Button href="https://www.sonicwebdev.com/terms-and-conditions" target="_blank" className={classes.button}>terms and conditions</Button>
          </Grid>
          </Grid>
        </Grid>
        </Paper>
        </div>
    );
  }
}

Review.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Review);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Review.js